import { isEmpty } from 'lodash-es';
import { Controller } from 'stimulus';
import TuitionService from '../entrypoints/src/admin/services/tuition-service';
import sweet_alert from '../entrypoints/src/admin/utilities/sweet_alert';

export default class extends Controller {
  static values = {
    tuitionId: String,
    chargeId: String
  }

  async updateCharge(ev) {
    let dueAt = this.element.querySelector('input[name="bank_bill_due_at"]').value;
    let bankBillEmail = this.element.querySelector('input[name="forward_email"]').value;

    try {
      let response = await TuitionService.updateChargeDueAt(this.tuitionIdValue, this.chargeIdValue, dueAt, bankBillEmail);

      sweet_alert({
        text: `Boleto atualizado com sucesso e encaminhado para o e-mail ${response.forwarded_to}`,
        title: 'Pronto',
        icon: 'success'
      }).then(() => {
        this.renderPaymentDetails(this.tuitionIdValue, this.chargeIdValue);
      });
    } catch (error) {
      sweet_alert({
        html: 'Não foi possível encaminhar o boleto via email <br> Verifique sua permissão para realizar tal operação',
        title: 'Falha',
        icon: 'error'
      });
    }
  }

  async forwardInvoiceNotification(ev) {
    ev.preventDefault();

    let $anchor = ev.currentTarget;
    let bankBillEmail = this.element.querySelector('input[name="bank_bill_email"]').value;

    if (isEmpty(bankBillEmail))
      return this.blankError('O e-mail é obrigatório!');

    try {
      let response = await TuitionService.fowardInvoiceAlert($anchor.dataset.tuitionId, $anchor.dataset.chargeId, bankBillEmail);

      sweet_alert({
        text: `Boleto foi enviado para o email ${response.forwarded_to}`,
        title: 'Pronto',
        icon: 'success'
      });
    } catch (error) {
      sweet_alert({
        html: 'Não foi possível encaminhar o boleto via email <br> Verifique sua permissão para realizar tal operação',
        title: 'Falha',
        icon: 'error'
      });
    }
  }

  async forwardReceiptListener(ev) {
    ev.preventDefault();

    let $anchor = ev.currentTarget;
    let receiptEmail = this.element.querySelector('input[name="receipt-email"]').value;

    if (isEmpty(receiptEmail))
      return this.blankError('O e-mail é obrigatório!');

    try {
      let response = await TuitionService.fowardReceipt($anchor.dataset.tuitionId, $anchor.dataset.chargeId, receiptEmail);

      sweet_alert({
        text: `Recibo foi enviado para o email ${response.forwarded_to}`,
        title: 'Pronto',
        icon: 'success'
      })
    } catch (error) {
      sweet_alert({
        html: 'Não foi possível encaminhar o recibo via email <br> Verifique sua permissão para realizar tal operação',
        title: 'Falha',
        icon: 'error'
      });
    }
  }

  blankError(text) {
    sweet_alert({
      text: text,
      title: 'Obrigatório',
      icon: 'error'
    })
  }
}